import React, { useState, useEffect } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import swal from 'sweetalert2';
import WebService from "../../../services/webservice";

const EditRole = ({ show, onHide, onSuccess, appMenus, roleToEdit }) => {
    const [formData, setFormData] = useState({
        id: '',
        roleName: '',
        status: 'Active',
        screenPermissions: []
    });

    const [expandedMenus, setExpandedMenus] = useState({});

    useEffect(() => {
        if (show && roleToEdit) {
            setFormData({
                id: roleToEdit._id,
                roleName: roleToEdit.roleName,
                status: roleToEdit.status,
                screenPermissions: roleToEdit.screenPermissions || []
            });
            setExpandedMenus({});
        }
    }, [show, roleToEdit]);

    const toggleMenu = (menuName) => {
        setExpandedMenus(prev => ({
            ...prev,
            [menuName]: !prev[menuName]
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handlePermissionChange = (menuKey, menuName, permission, isChecked) => {
        let updatedPermissions = [...formData.screenPermissions];
        const menuIndex = updatedPermissions.findIndex(p => p.menuKey === menuKey);

        if (menuIndex !== -1) {
            let menuPerms = updatedPermissions[menuIndex];
            if (isChecked) {
                if (!menuPerms.permissions.includes(permission)) {
                    menuPerms.permissions.push(permission);
                }
            } else {
                menuPerms.permissions = menuPerms.permissions.filter(p => p !== permission);
            }
            if (menuPerms.permissions.length === 0) {
                updatedPermissions = updatedPermissions.filter(p => p.menuKey !== menuKey);
            } else {
                updatedPermissions[menuIndex] = menuPerms;
            }
        } else {
            if (isChecked) {
                updatedPermissions.push({
                    menuKey,
                    menuName,
                    permissions: [permission]
                });
            }
        }
        setFormData({ ...formData, screenPermissions: updatedPermissions });
    };

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            const allPermissions = appMenus.map(menu => ({
                menuKey: menu.menuKey,
                menuName: menu.menuName,
                permissions: [...(menu.allowedActions || [])]
            })).filter(m => m.permissions.length > 0); 
            setFormData({ ...formData, screenPermissions: allPermissions });
        } else {
            setFormData({ ...formData, screenPermissions: [] });
        }
    };

    const isAllSelected = () => {
        let totalActions = 0;
        appMenus.forEach(menu => {
            if (menu.allowedActions) {
                totalActions += menu.allowedActions.length;
            }
        });
        let selectedActions = 0;
        formData.screenPermissions.forEach(screen => {
            selectedActions += screen.permissions.length;
        });
        return totalActions > 0 && totalActions === selectedActions;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let submitData = { ...formData };
            if (submitData.roleName.trim() === 'Super Admin') {
                const fixedMenus = ['Role Management', 'App Menu', 'Admin Creation'];
                let updatedPermissions = [...submitData.screenPermissions];

                appMenus.forEach(menu => {
                    if (fixedMenus.includes(menu.menuName) && menu.allowedActions) {
                        const existingIdx = updatedPermissions.findIndex(p => p.menuKey === menu.menuKey);
                        if (existingIdx !== -1) {
                            updatedPermissions[existingIdx] = { ...updatedPermissions[existingIdx], permissions: [...menu.allowedActions] };
                        } else {
                            updatedPermissions.push({
                                menuKey: menu.menuKey,
                                menuName: menu.menuName,
                                permissions: [...menu.allowedActions]
                            });
                        }
                    }
                });
                submitData.screenPermissions = updatedPermissions;
            }

            const response = await axios.post(`${WebService}api/update-role`, submitData);

            if (response.data.success) {
                swal.fire('Success', response.data.message, 'success');
                if (onSuccess) onSuccess();
                onHide();
            } else {
                swal.fire('Error', response.data.message, 'error');
            }
        } catch (error) {
            console.error('Error updating role:', error);
            swal.fire('Error', 'Something went wrong while updating.', 'error');
        }
    };

    if (!show) return null;

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 }}>
            <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', width: '90%', maxWidth: '900px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
                <div style={{ padding: '24px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#ffffff', borderBottom: '1px solid #e2e8f0', flexShrink: 0 }}>
                    <h2 style={{ margin: 0, fontWeight: '700', color: '#1e293b', fontSize: '1.35rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ background: '#eff6ff', padding: '8px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="fa-solid fa-pen-to-square" style={{ color: '#3b82f6', fontSize: '1rem' }}></i>
                        </div>
                        Edit Role
                    </h2>
                    <button type="button" onClick={onHide} style={{ background: 'transparent', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#64748b', padding: '0' }}>&times;</button>
                </div>
                <Form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', flexGrow: 1 }}>
                    <div style={{ padding: '24px 32px', overflowY: 'auto', flexGrow: 1, backgroundColor: '#f8fafc' }}>
                        <Row className="gx-4">
                            <Col md={6}>
                                <Form.Group className="mb-4">
                                    <Form.Label style={{ color: '#64748b', fontWeight: '600', fontSize: '0.85rem', marginBottom: '8px', textTransform: 'capitalize', letterSpacing: '0.2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <i className="fa-solid fa-id-badge" style={{ color: '#64748b', fontSize: '0.9rem' }}></i> Role Name <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter role name"
                                        name="roleName"
                                        value={formData.roleName}
                                        onChange={handleInputChange}
                                        required
                                        style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', boxShadow: 'none', transition: 'all 0.2s', fontSize: '0.85rem', backgroundColor: '#ffffff' }}
                                        onFocus={(e) => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 4px rgba(59, 130, 246, 0.1)'; }}
                                        onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-4">
                                    <Form.Label style={{ color: '#64748b', fontWeight: '600', fontSize: '0.85rem', marginBottom: '8px', textTransform: 'capitalize', letterSpacing: '0.2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <i className="fa-solid fa-toggle-on" style={{ color: '#64748b', fontSize: '0.9rem' }}></i> Status <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="status"
                                        value={formData.status}
                                        onChange={handleInputChange}
                                        required
                                        style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', boxShadow: 'none', transition: 'all 0.2s', fontSize: '0.85rem', backgroundColor: '#ffffff', cursor: 'pointer' }}
                                        onFocus={(e) => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 4px rgba(59, 130, 246, 0.1)'; }}
                                        onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
                                    >
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Screen Permissions Section */}
                        <div style={{ marginTop: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #e2e8f0', padding: '20px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                                <h5 style={{ fontWeight: '600', margin: 0, color: '#1e293b', fontSize: '1rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <i className="fa-solid fa-list-check" style={{ color: '#3b82f6' }}></i> Screen Permissions
                                </h5>
                                <Form.Check
                                    type="checkbox"
                                    id="select-all-edit"
                                    label={<span style={{ color: '#1e293b', fontWeight: '600', fontSize: '0.9rem' }}>Select All</span>}
                                    checked={isAllSelected()}
                                    onChange={handleSelectAll}
                                    style={{ accentColor: '#3b82f6' }}
                                />
                            </div>

                            <div className="role-permissions-container" style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflowY: 'auto', maxHeight: '400px' }}>
                                <table className="role-permissions-table" style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#ffffff' }}>
                                    <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                        <tr style={{ backgroundColor: '#f8fafc' }}>
                                            <th style={{ padding: '12px 16px', fontWeight: '600', color: '#64748b', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #e2e8f0' }}>Screen Name</th>
                                            <th style={{ padding: '12px 16px', fontWeight: '600', color: '#64748b', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #e2e8f0' }}>Permissions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {appMenus.filter(m => m.menuType !== 'Sub Menu').map((menu) => {
                                            const roleScreenPerms = formData.screenPermissions.find(p => p.menuKey === menu.menuKey) || { permissions: [] };

                                            const subMenus = appMenus.filter(m => m.menuType === 'Sub Menu' && m.parentMenu === menu.menuName);
                                            const hasSubMenus = subMenus.length > 0;
                                            const isExpanded = expandedMenus[menu.menuName];

                                            const isSuperAdmin = formData.roleName.trim() === 'Super Admin';
                                            const fixedSuperAdminMenus = ['Role Management', 'App Menus', 'App Menu', 'Admin Creation'];
                                            const isFixedMenu = isSuperAdmin && fixedSuperAdminMenus.includes(menu.menuName);
                                            const rowStyle = isFixedMenu ? { opacity: 0.6, pointerEvents: 'none' } : {};

                                            return (
                                                <React.Fragment key={menu.menuKey}>
                                                    <tr style={{ borderBottom: '1px solid #e2e8f0', ...rowStyle }}>
                                                        <td style={{ padding: '12px 16px', fontWeight: '600', color: '#1e293b', fontSize: '0.9rem' }}>
                                                            <div
                                                                style={{ display: 'flex', alignItems: 'center', cursor: hasSubMenus ? 'pointer' : 'default', userSelect: 'none' }}
                                                                onClick={() => hasSubMenus && toggleMenu(menu.menuName)}
                                                            >
                                                                {menu.menuName}
                                                                {hasSubMenus && (
                                                                    <i className={`fa-solid ${isExpanded ? 'fa-angle-down' : 'fa-angle-right'}`} style={{ marginLeft: '10px', color: '#94a3b8', fontSize: '0.8rem' }}></i>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td style={{ padding: '12px 16px' }}>
                                                            {menu.allowedActions && menu.allowedActions.length > 0 ? (
                                                                <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                                                                    {menu.allowedActions.map((action, idx) => (
                                                                        <Form.Check
                                                                            key={idx}
                                                                            type="checkbox"
                                                                            id={`perm-edit-${menu.menuKey}-${action}`}
                                                                            label={<span style={{ color: '#475569', fontWeight: '500', fontSize: '0.85rem' }}>{action}</span>}
                                                                            checked={isFixedMenu ? true : roleScreenPerms.permissions.includes(action)}
                                                                            disabled={isFixedMenu}
                                                                            onChange={(e) => handlePermissionChange(menu.menuKey, menu.menuName, action, e.target.checked)}
                                                                            style={{ accentColor: '#3b82f6' }}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <span style={{ color: '#94a3b8', fontSize: '0.85rem', fontStyle: 'italic' }}>No specific actions defined</span>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {isExpanded && subMenus.map((childMenu) => {
                                                        const childPerms = formData.screenPermissions.find(p => p.menuKey === childMenu.menuKey) || { permissions: [] };
                                                        const isFixedChild = isSuperAdmin && fixedSuperAdminMenus.includes(childMenu.menuName);
                                                        const childRowStyle = isFixedChild ? { opacity: 0.6, pointerEvents: 'none' } : {};
                                                        return (
                                                            <tr key={childMenu.menuKey} style={{ borderBottom: '1px solid #e2e8f0', backgroundColor: '#f8fafc', ...childRowStyle }}>
                                                                <td style={{ padding: '12px 16px' }}>
                                                                    <span style={{
                                                                        marginLeft: '25px',
                                                                        backgroundColor: '#eff6ff',
                                                                        color: '#2563eb',
                                                                        padding: '4px 10px',
                                                                        borderRadius: '4px',
                                                                        fontSize: '0.8rem',
                                                                        fontWeight: '600',
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        gap: '6px'
                                                                    }}>
                                                                        <i className="fa-solid fa-level-up fa-rotate-90" style={{ fontSize: '0.7rem' }}></i> {childMenu.menuName}
                                                                    </span>
                                                                </td>
                                                                <td style={{ padding: '12px 16px' }}>
                                                                    {childMenu.allowedActions && childMenu.allowedActions.length > 0 ? (
                                                                        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                                                                            {childMenu.allowedActions.map((action, idx) => (
                                                                                <Form.Check
                                                                                    key={`child-${idx}`}
                                                                                    type="checkbox"
                                                                                    id={`perm-edit-${childMenu.menuKey}-${action}`}
                                                                                    label={<span style={{ color: '#475569', fontWeight: '500', fontSize: '0.85rem' }}>{action}</span>}
                                                                                    checked={isFixedChild ? true : childPerms.permissions.includes(action)}
                                                                                    disabled={isFixedChild}
                                                                                    onChange={(e) => handlePermissionChange(childMenu.menuKey, childMenu.menuName, action, e.target.checked)}
                                                                                    style={{ accentColor: '#3b82f6' }}
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                    ) : (
                                                                        <span style={{ color: '#94a3b8', fontSize: '0.85rem', fontStyle: 'italic' }}>No specific actions defined</span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            );
                                        })}
                                        {appMenus.length === 0 && (
                                            <tr>
                                                <td colSpan="2" style={{ textAlign: 'center', padding: '30px', color: '#64748b', fontSize: '0.9rem' }}>No screens available to set permissions.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                    <div style={{ padding: '16px 32px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', gap: '12px', backgroundColor: '#f8fafc', flexShrink: 0 }}>
                        <button
                            type="button"
                            onClick={onHide}
                            style={{ padding: '8px 20px', borderRadius: '6px', border: '1px solid #e2e8f0', backgroundColor: '#ffffff', color: '#64748b', fontWeight: '600', fontSize: '0.9rem', cursor: 'pointer', transition: 'all 0.2s' }}
                            onMouseOver={(e) => { e.target.style.backgroundColor = '#f1f5f9'; e.target.style.color = '#0f172a'; }}
                            onMouseOut={(e) => { e.target.style.backgroundColor = '#ffffff'; e.target.style.color = '#64748b'; }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            style={{ padding: '8px 24px', borderRadius: '6px', border: 'none', backgroundColor: '#3b82f6', color: '#ffffff', fontWeight: '600', fontSize: '0.9rem', cursor: 'pointer', transition: 'all 0.2s', boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)' }}
                            onMouseOver={(e) => { e.target.style.backgroundColor = '#2563eb'; e.target.style.boxShadow = '0 4px 6px rgba(59, 130, 246, 0.4)'; }}
                            onMouseOut={(e) => { e.target.style.backgroundColor = '#3b82f6'; e.target.style.boxShadow = '0 2px 4px rgba(59, 130, 246, 0.3)'; }}
                        >
                            Update Role
                        </button>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default EditRole;
